import { render, staticRenderFns } from "./InformationsPerso.vue?vue&type=template&id=a855e63e&scoped=true"
import script from "./InformationsPerso.vue?vue&type=script&lang=js"
export * from "./InformationsPerso.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Um6pAutresRevenus.css?vue&type=style&index=0&id=a855e63e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a855e63e",
  null
  
)

export default component.exports